import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedin,
  FaGlobe,
  FaMapMarkerAlt,
  FaTrophy,
  FaGraduationCap,
  FaCode,
  FaBookOpen,
  FaBriefcase,
  FaLanguage,
  FaHeart,
} from "react-icons/fa";
import "./SimpleProfessionalTemplate.css";

const SimpleProfessionalTemplate = ({ resumeData }) => {
  if (!resumeData) return <div className="loading-placeholder">Loading...</div>;

  const {
    personal = {},
    experience = [],
    education = [],
    skills = { technical: [], soft: [], languages: [] },
    achievements = [],
    certifications = [],
    interests = [],
  } = resumeData;

  // Combine all skills for left column
  const allSkills = [...skills.technical, ...skills.soft];

  return (
    <div className="resume-template simple-professional">
      {/* LEFT COLUMN (Dark / Accent) */}
      <div className="sp-left-column">
        {/* Key Achievements */}
        {achievements.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title">
              <FaTrophy /> KEY ACHIEVEMENTS
            </h3>
            <div className="sp-achievements-list">
              {achievements.map((ach, idx) => (
                <div key={idx} className="sp-achievement-item">
                  <div className="sp-ach-number">{idx + 1}️⃣</div>
                  <div className="sp-ach-content">
                    <div className="sp-ach-title">
                      {ach.split(" ").slice(0, 3).join(" ")}
                    </div>
                    <div className="sp-ach-desc">{ach}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Education */}
        {education.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title">
              <FaGraduationCap /> EDUCATION
            </h3>
            {education.map((edu, idx) => (
              <div key={edu.id || idx} className="sp-edu-item">
                <div className="sp-edu-degree">{edu.degree || "Degree"}</div>
                <div className="sp-edu-school">{edu.institution || "School"}</div>
                <div className="sp-edu-meta">
                  <span>{edu.year || "Year"}</span>
                  <span>{edu.location || "Location"}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Skills */}
        {allSkills.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title">
              <FaCode /> SKILLS
            </h3>
            <div className="sp-skills-list">
              {allSkills.map((skill, idx) => (
                <span key={idx} className="sp-skill-tag">{skill}</span>
              ))}
            </div>
          </div>
        )}

        {/* Training / Courses (Certifications) */}
        {certifications.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title">
              <FaBookOpen /> TRAINING / COURSES
            </h3>
            {certifications.map((cert, idx) => (
              <div key={cert.id || idx} className="sp-course-item">
                <div className="sp-course-title">{cert.name}</div>
                <div className="sp-course-issuer">{cert.issuer}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* RIGHT COLUMN (White / Main) */}
      <div className="sp-right-column">
        {/* Header: Name + Role */}
        <div className="sp-header">
          <h1 className="sp-name">{personal.fullName || "YOUR NAME"}</h1>
          <div className="sp-role">{personal.title || "The role you are applying for?"}</div>
        </div>

        {/* Contact Bar */}
        <div className="sp-contact-bar">
          {personal.email && <span><FaEnvelope /> {personal.email}</span>}
          {personal.phone && <span><FaPhoneAlt /> {personal.phone}</span>}
          {personal.linkedin && <span><FaLinkedin /> LinkedIn</span>}
          {personal.portfolio && <span><FaGlobe /> Portfolio</span>}
          {personal.address && <span><FaMapMarkerAlt /> {personal.address}</span>}
        </div>

        {/* Summary */}
        {personal.summary && (
          <div className="sp-section">
            <h3 className="sp-section-title-right">SUMMARY</h3>
            <div className="sp-summary">{personal.summary}</div>
          </div>
        )}

        {/* Experience */}
        {experience.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title-right">
              <FaBriefcase /> EXPERIENCE
            </h3>
            {experience.map((exp, idx) => (
              <div key={exp.id || idx} className="sp-exp-item">
                <div className="sp-exp-title">{exp.title || "Title"}</div>
                <div className="sp-exp-company">{exp.company || "Company Name"}</div>
                <ul className="sp-exp-desc">
                  {exp.description?.split("\n").map((line, i) => (
                    <li key={i}>{line || "Highlight your accomplishments, using numbers if possible."}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* Languages */}
        {skills.languages?.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title-right">
              <FaLanguage /> LANGUAGES
            </h3>
            <div className="sp-languages">
              {skills.languages.map((lang, idx) => (
                <span key={idx} className="sp-lang-item">{lang}</span>
              ))}
            </div>
          </div>
        )}

        {/* Interests */}
        {interests.length > 0 && (
          <div className="sp-section">
            <h3 className="sp-section-title-right">
              <FaHeart /> INTERESTS
            </h3>
            <div className="sp-interests">
              {interests.map((interest, idx) => (
                <div key={idx} className="sp-interest-item">
                  <div className="sp-interest-title">{interest}</div>
                  <div className="sp-interest-desc">
                    What does the company have which makes it attractive for you? (e.g. learning opportunities)
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleProfessionalTemplate;